<template>
    <div class="call-center">
        <!-- <ul>
      <li class="" v-for="item in tableData" :key="item.index">
        <img src="../assets/img/u25928.png" alt="" />
        <p><span>姓名：</span><span>{{item.name}}</span></p>
        <p>18656596714</p>
      </li>
    </ul> -->
        <el-carousel class="carousel">
            <el-carousel-item v-for="(item, index) in tableData" :key="index">
                <img :src="item.img" alt="" srcset="" class="carouselImg" />
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
    data() {
        return {
            sexList: [],
            tableData: [
                { img: require("../assets/img/face1.png") },
                { img: require("../assets/img/face2.png")  },
            ],
        }
    },

    mounted() {},
    methods: {},
}
</script>
<style lang="less" scoped>
.call-center {
    width: 100%;
    padding: 20px;
    background: #091627;
    color: #5caefe;
    li {
        float: left;
        width: 32%;
        padding-bottom: 10px;
        img {
            width: 85px;
            height: 45px;
        }
        p {
            font-size: 14px;
            padding-top: 6px;
        }
    }
}
.carousel {
    width: 100%;
    height: 200px;
}
.carouselImg {
    width: 100%;
    height: 170px;
}
</style>


